export default "__VITE_ASSET__D$iftDbd__"